import { useDebounce } from "@uidotdev/usehooks"
import { ChangeEvent, FC, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  InputFieldWrapper,
  SelectWrapper,
} from "src/features/shared-module/components"

interface CommonQueryFilterProps {
  onChangeQuery: any
  initialQuery: string | null
}

export const CommonQueryFilter: FC<CommonQueryFilterProps> = ({
  initialQuery = null,
  onChangeQuery,
}) => {
  const { t } = useTranslation()
  const [query, setQuery] = useState<string | null>(initialQuery)
  const debouncedQuery = useDebounce(query, 500)

  useEffect(() => {
    if (debouncedQuery === null) {
      return
    }
    onChangeQuery(debouncedQuery)
  }, [debouncedQuery, onChangeQuery])

  const onSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value)
  }

  return (
    <InputFieldWrapper
      data-testid="orders-search-input"
      margin="none"
      name="search-order"
      placeholder={t("search")}
      size="small"
      value={query}
      onChange={onSearch}
    />
  )
}

export const CommonSorting: FC<{ options: any[]; onChangeSort: any }> = ({
  options,
  onChangeSort,
}) => {
  const { t } = useTranslation()
  return (
    <SelectWrapper
      data-testid="orders-sort-select"
      margin="none"
      name="sorting-field"
      label={t("sortBy")}
      options={options}
      size="small"
      onChange={onChangeSort}
    />
  )
}
